// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "googlepay-1Jd1d";
var _3 = "applepay-37fC7";
export { _1 as "__esModule", _2 as "googlepay", _3 as "applepay" }
export default { "__esModule": _1, "googlepay": _2, "applepay": _3 }
